export default __webpack_public_path__ + "static/media/dewgong.0f449e78.png";